import React, { useState, useRef } from "react";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";

function InputCreate({
  label,
  typeInput,
  nameInput,
  active,
  handleChangePassword,
  getValue,
  dataValue,
  isRequired,
  MydefaultValue,
  minValueInput,
  maxValueInput,
  isDisabledInput,
  isMinActive,
}) {
  const [togglePasswordContent, setTogglePasswordContent] = useState(false);
  const passwordRef = useRef(null);

  const handlePassword = () => {
    setTogglePasswordContent((prevTogglePassword) => !prevTogglePassword);
    if (!togglePasswordContent) {
      passwordRef.current.type = "text";
    } else {
      passwordRef.current.type = "password";
    }
  };
  return (
    <div className="input-label-profil">
      <label htmlFor={nameInput}>{label}</label>
      <br />
      {!active ? (
        <div className="conteneur-password">
          {togglePasswordContent ? (
            <span className="icon-eye" onClick={handlePassword}>
              <AiOutlineEye />
            </span>
          ) : (
            <span className="icon-hidden-eye" onClick={handlePassword}>
              <AiOutlineEyeInvisible />
            </span>
          )}
          <input
            style={{ backgroundColor: "white" }}
            ref={passwordRef}
            type={typeInput}
            required={isRequired}
            min={
              typeInput === "date" ? new Date().toISOString().slice(0, 10) :  (typeInput === "date" || isMinActive) ? minValueInput : null
            }
            max={
              (typeInput === "number" || typeInput === "date")
                ? maxValueInput
                : null
            }
            value={dataValue}
            onChange={handleChangePassword}
          />
        </div>
      ) : MydefaultValue ? (
        <input
          type={typeInput}
          required={isRequired}
          defaultValue={dataValue}
          disabled={isDisabledInput}
          min={
              typeInput === "date" ? new Date().toISOString().slice(0, 10) :  (typeInput === "date" || isMinActive) ? minValueInput : null
            }
          
          onChange={getValue}
        />
      ): (
        <input
          type={typeInput}
          required={isRequired}
          value={dataValue}
          disabled={isDisabledInput}
          min={
            typeInput === "date" ? new Date().toISOString().slice(0, 10) : typeInput === "number" ? 1 : 
            (typeInput === "date" || isMinActive) ? minValueInput : null
          }
          onChange={getValue}
        />
      )}
    </div>
  );
}

export default InputCreate;
